import { render } from "./Digitisation.vue?vue&type=template&id=1aa1408c&scoped=true"
import script from "./Digitisation.vue?vue&type=script&lang=js"
export * from "./Digitisation.vue?vue&type=script&lang=js"

import "./Digitisation.vue?vue&type=style&index=0&id=1aa1408c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa1408c"]])

export default __exports__